import { useInfiniteQuery } from '@tanstack/react-query'
import { getBlogHomeGroqQueryAndParams } from '../../../sanity/groqQueries'
import { BLOG_HOME_QUERY_MAIN_MENUResult } from '../../../sanity/types'
import client from '../../sanityClient'

interface FetchGetBlogPostRequest {
  start: number // 시작 인덱스
  end: number // 끝 인덱스
  selectedMenuId: string | number
  selectedSubMenuId: string | number
  lang: string | string[]
}

/**
 * 블로그 포스트를 가져오는 함수
 */
export const fetchGetBlogPost = async ({
  start,
  end,
  selectedMenuId,
  selectedSubMenuId,
  lang,
}: FetchGetBlogPostRequest): Promise<BLOG_HOME_QUERY_MAIN_MENUResult> => {
  const { query, params } = getBlogHomeGroqQueryAndParams(start, end, selectedMenuId, selectedSubMenuId, lang)

  const posts: BLOG_HOME_QUERY_MAIN_MENUResult = await client.fetch(query, params)

  return posts
}

export const useBlogPostInfiniteQuery = ({
  params,
  offset,
}: {
  params: Omit<FetchGetBlogPostRequest, 'start' | 'end'>
  offset?: number
}) => {
  return useInfiniteQuery({
    queryKey: ['blogPostInfiniteQuery', params],
    queryFn: ({ pageParam = 0 }) =>
      fetchGetBlogPost({
        ...params,
        start: pageParam,
        end: pageParam + offset - 1,
      }),
    getNextPageParam: (lastPage, allPages) => {
      // 받아온 데이터 수가 offset보다 작으면 다음 없음
      return lastPage.length === offset ? allPages.length * offset : undefined
    },
    keepPreviousData: true,
  })
}
